import { render, staticRenderFns } from "./Agente.vue?vue&type=template&id=1a2a7275&scoped=true"
import script from "./Agente.vue?vue&type=script&lang=js"
export * from "./Agente.vue?vue&type=script&lang=js"
import style0 from "./Agente.vue?vue&type=style&index=0&id=1a2a7275&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2a7275",
  null
  
)

export default component.exports